<template>
    
    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">

        

        <!-- SIDEBAR -->
        <SidebarBody/>

        

        <div class="hp-main-layout">

            <!-- HEADER -->
            <HeaderBody/>
            
            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content" style="padding-left: 10px; padding-right: 10px;">

                <div class="row mb-32 gy-0 dash-top">

                    <!-- POSTS -->
                    <div class="col-12" >

                        <div class="row g-32 " >

                            <div class="col-12 col-xl-8" style="z-index: 9; padding-bottom: 500px;">

                                <!-- <h2 class="mm-none">User Lists</h2> -->
                                <h2 class="dd-none" style="margin-top: -20px;"></h2>
                                

                                <!-- TABS -->
                                <ul class="nav nav-tabs mb-12" id="myTab" role="tablist" style="overflow-x:auto;
                                flex-wrap:nowrap; scrollbar-width: none; margin-top: -10px;">
                                    
                                    
                                            
                                    <li class="nav-item" role="presentation"  >
                                        <h6 class="nav-link active" id="following-tab" data-bs-toggle="tab" data-bs-target="#following"  role="tab" aria-controls="following" aria-selected="false" style="cursor: pointer;
                                ">Following <strong style="margin-left: 5px;">{{ followingCount }}</strong></h6>
                                    </li>

                                    <li class="nav-item" role="presentation" >
                                        <h6 class="nav-link" id="followers-tab" data-bs-toggle="tab" data-bs-target="#followers"  role="tab" aria-controls="followers" aria-selected="false" style="cursor: pointer;">Followers <strong style="margin-left: 5px;">{{ followerCount }}</strong></h6>
                                    </li>

                                    <li class="nav-item" role="presentation">
                                        <h6 class="nav-link" id="fans-tab" data-bs-toggle="tab" data-bs-target="#fans"  role="tab" aria-controls="fans" aria-selected="true" style="cursor: pointer;">Fans <strong style="margin-left: 5px;">{{ fanCount }}</strong></h6>
                                    </li>

                                </ul>

                                <!-- TAB CONTENT -->
                                <div  class="tab-content" id="allTabContent" >
                                    

                                    <!-- FOLLOWING -->
                                    <div class="tab-pane fade show active" id="following" role="tabpanel" aria-labelledby="following-tab" style="padding-bottom: 1000px;">
                                        
                                        <div  >
                                            <div class="card-bod " >
                                                <div class="row" >

                                                    <div style="margin-top: 200px;  display: flex; justify-content: center; align-items: center; flex-direction: column;" id="emptyFollowing">
                                                            <p class="hp-badge-text">No following yet...</p>
                                                    </div>

                                                    <!-- SINGLE SUB -->
                                                    <div class="col-12 col-xl-12" style="margin-bottom: 10px;" v-for="(fol, index) in followingList" :key="'number'+index">
                                                        <div class="card hp-card-1" style="border-radius: 15px;">
                                                            <div class="card-body" >

                                                                <!-- <div class="d-flex justify-content-center align-items-center" style="position: absolute; top: 2px; right: 2px;">

                                                                    <button data-bs-toggle="modal" data-bs-target="#unfollow" class="btn btn-sm btn-danger dd-none" @click="unFollowClick(fol)">Unfollow</button>

                                                                </div> -->

                                                                <div class="row ">

                                                                    <div class=" d-flex justify-content-between align-items-center"  style="width: 100%; padding-left: 20px; padding-right: 20px; cursor: pointer;">

                                                                        <div class="row d-flex align-items-center">
                                                                            <div class="w-auto px-0" @click="profileClick(fol.userId, fol.username)">
                                                                                <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle pImx" >
                                                                                    <img :src="fol.profilePic"  class="hp-img-cover" style=" background-color: black; object-fit: cover; border-width: 1px; border-style: solid; border-color: #000;">
                                                                                </div>
                                                                            </div>

                                                                            <div class="w-auto ms-8 px-0 mt-12" @click="profileClick(fol.userId, fol.username)">
                                                                                <span class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleS pTxxt" >{{ fol.name }} </span>
                                                                                <p style="font-size: 12px; " class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">@{{ fol.username }}</p>

                                                                            </div>

                                                                            
                                                                        </div>

                                                                        <div class="row justify-content-center align-items-center">

                                                                            <button class="btn btn-danger mm-none" data-bs-toggle="modal" data-bs-target="#unfollow" @click="unFollowClick(fol)">Unfollow</button>

                                                                            <button class="btn btn-sm btn-danger dd-none" data-bs-toggle="modal" data-bs-target="#unfollow" @click="unFollowClick(fol)">Unfollow</button>

                                                                        </div>

                                                                    </div>

                                                                    

                                                                </div>

                                                                

                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <!-- FOLLOWERS -->
                                    <div class="tab-pane fade " id="followers" role="tabpanel" aria-labelledby="followers-tab" style="padding-bottom: 1000px;">

                                        <div class="" >
                                            <div class="card-bod " >
                                                <div class="row" >

                                                    <div style="margin-top: 200px;  display: flex; justify-content: center; align-items: center; flex-direction: column;" id="emptyFollowers">
                                                            <p class="hp-badge-text">No followers yet...</p>
                                                    </div>

                                                    <!-- SINGLE SUB -->
                                                    <div class="col-12 col-xl-12" style="margin-bottom: 10px; " v-for="(fol, index) in followerList" :key="'number'+index">
                                                        <div class="card hp-card-1" style="border-radius: 15px;">
                                                            <div class="card-body" >

                                                                

                                                                <div class="row " >

                                                                    <div class=" d-flex justify-content-between align-items-center" style="width: 100%; padding-left: 20px; padding-right: 20px; cursor: pointer;">

                                                                        <div class="row d-flex align-items-center " >
                                                                            <div class="w-auto px-0" @click="profileClick(fol.userId, fol.username)">
                                                                                <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle pImx" >
                                                                                    <img :src="fol.profilePic"  class="hp-img-cover" style="background-color: black; object-fit: cover; border-width: 1px; border-style: solid; border-color: #000;">
                                                                                </div>

                                                                                
                                                                            </div>

                                                                            <div class="w-auto ms-8 px-0 mt-12" @click="profileClick(fol.userId, fol.username)" >
                                                                                <span class="d-block hp-text-color-black-100 hp-text-color-dark-0  lh-1 titleS pTxxt"> {{ fol.name }}  </span>
                                                                                <p style="font-size: 12px; " class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">@{{ fol.username }}</p>

                                                                            </div>

                                                                            

                                                                            
                                                                        </div>

                                                                        <div class="row justify-content-center align-items-center" >

                                                                            <button @click="goMessage" v-if="fol.followBack" class="btn btn-primary mm-none">  Message</button>

                                                                            <button  v-else class="btn btn-outline-primary mm-none" @click="followUser(fol)">Follow back</button>

                                                                            <button @click="goMessage" v-if="fol.followBack" class="btn btn-sm btn-primary dd-none">   Message</button>

                                                                            <button v-else class="btn btn-sm btn-outline-primary dd-none" @click="followUser(fol)">Follow back</button>
                                                                            

                                                                        </div>

                                                                        

                                                                    </div>

                                                                    

                                                                </div>

                                                                

                                                            </div>
                                                        </div>
                                                    </div>

                                                    

                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <!-- FANS -->
                                    <div class="tab-pane fade " id="fans" role="tabpanel" aria-labelledby="fans-tab" style="padding-bottom: 1000px;">
                                        
                                        <div  >
                                            <div class="card-bod " >
                                                <div class="row" >

                                                    <div style="margin-top: 200px; display: flex; justify-content: center; align-items: center; flex-direction: column;" id="emptyFans">
                                                            <p class="hp-badge-text">No fans yet...</p>
                                                    </div>

                                                    <!-- SINGLE SUB -->
                                                    <div class="col-12 col-xl-12" style="margin-bottom: 10px;" v-for="(fan, index) in fanList" :key="'number'+index">
                                                        <div class="card hp-card-1" style="border-radius: 15px;">
                                                            <div class="card-body" >

                                                                <div class="row " >

                                                                    <div class=" d-flex justify-content-between align-items-center" style="width: 100%; padding-left: 20px; padding-right: 20px; cursor: pointer;">

                                                                        <div class="row align-items-center">
                                                                            <div class="w-auto px-0" @click="profileClick(fan.userId, fol.username)">
                                                                                <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle pImx" >
                                                                                    <img :src="fan.profilePic"  class="hp-img-cover" style=" background-color: black; object-fit: cover; border-width: 1px; border-style: solid; border-color: #000;">
                                                                                </div>
                                                                            </div>

                                                                            <div class="w-auto ms-8 px-0 mt-12">
                                                                                <span class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleM pTxxt" >{{ fan.fullName }} </span>
                                                                                <p style="font-size: 12px; " class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">@{{ fan.username }}</p>

                                                                            </div>

                                                                            

                                                                            
                                                                        </div>

                                                                        <div class="row d-flex justify-content-center align-items-center ">

                                                                            <button @click="goMessage" class="btn btn-primary mm-none">Message</button>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div class="divider mt-8 mb-16"></div>

                                                                <div class="d-flex align-items-center justify-content-center" style="width: 100%;">

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                                                                        <p style="text-align: start; width: 100%;" class="hp-badge-text">Amount paid</p>

                                                                        <p style="text-align: end; width: 100%;" class="hp-badge-text text-black-100">NGN {{ fan.priceD }}</p>
                                                                    </div>

                                                                </div>

                                                                <div class="d-flex align-items-center justify-content-center" style="width: 100%;">

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                                                                        <p style="text-align: start; width: 100%;" class="hp-badge-text">Duration</p>

                                                                        <p style="text-align: end; width: 100%;" class="hp-badge-text text-black-100">{{ fan.duration }} days</p>
                                                                    </div>

                                                                </div>

                                                                <div class="d-flex align-items-center justify-content-center" style="width: 100%;">

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                                                                        <p style="text-align: start; width: 100%;" class="hp-badge-text">Start date</p>

                                                                        <p style="text-align: end; width: 100%;" class="hp-badge-text text-black-100"> {{ fan.startDateD }}</p>
                                                                    </div>

                                                                </div>

                                                                <div class="d-flex align-items-center justify-content-center" style="width: 100%;">

                                                                    <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                                                                        <p style="text-align: start; width: 100%;" class="hp-badge-text">Expiration date</p>

                                                                        <p style="text-align: end; width: 100%;" class="hp-badge-text text-black-100"> {{ fan.endDateD }}</p>
                                                                    </div>

                                                                </div>

                                                                <div class="d-flex justify-content-center align-items-center mt-8">

                                                                    <button @click="goMessage" class="btn btn-primary dd-none">Message</button>

                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>

                                                    


                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>

                            <!-- SUGGESTIONS -->
                            <div class="col-12 col-xl-4">

                                <SuggestionsBody/>

                            </div>
                            

                        </div>

                    </div>

                    
                </div>

                 <!-- FOOTER -->
                <FooterBody/>

            </div>

        </div>

    </main>


    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px" width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"></path>
                </g>
            </svg>
        </button>
    </div>

    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="successModal2">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText2}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS2">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- UNFOLLOW -->
        <div class="modal fade" id="unfollow" tabindex="-1" aria-labelledby="unfollowLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        
                        <h4 class="modal-title">Unfollow @{{ unfUsername }}?</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    

                    <div class="modal-body" style="margin-top: -30px;">

                        <p class="hp-p1-body"> Their posts might no longer appear on your home timeline. You can still view their profile </p>
                        
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-text" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-danger" @click="unfollowUser" data-bs-dismiss="modal">Unfollow</button>
                    </div>
                </div>
            </div>
        </div>

</template>



<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import SuggestionsBody from '@/components/SuggestionsBody.vue';
    import FooterBody from '@/components/FooterBody.vue';
    import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
    import "../../node_modules/v3-infinite-loading/lib/style.css";

    import TimeAgo from 'javascript-time-ago';
    import en from 'javascript-time-ago/locale/en';

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, setDoc, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, arrayRemove } from "firebase/firestore"; 
    import {getAuth, onAuthStateChanged, signOut} from "firebase/auth"
    import { db } from '@/firebase';

    export default {

        components: {
            SidebarBody,
            HeaderBody,
            SuggestionsBody,
            FooterBody,
            InfiniteLoading,
        },

        data(){
            return{

                loadingText:"",
                errorText: "",
                successText: "",
                successText2: "",

                followerList: [],
                followingList: [],
                fanList: [],

                followerCount: 0,
                followingCount: 0,
                fanCount: 0,

                followerIdList: [],
                followingIdList: [],
                fanIdList: [],

                spamCount: 0,

                unfUsername: "",
                unfUserId: "",

            }
        },

        mounted(){

            document.body.style.overflowY = 'scroll';
            document.getElementById("mobileLogo").style.display= 'none';
            document.getElementById("mobileTitle").textContent = 'User Lists';

            document.getElementById("collectionN").classList.add("active");
            document.getElementById("collectionN").classList.add("arrow-active");
            
            
            document.getElementById("collectionN2").classList.add("active");
            document.getElementById("collectionN2").classList.add("arrow-active");
            
            

            this.getFollowing();
            
        },

        methods:{

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            getOccurrence(array, value) {
                var count = 0;
                array.forEach((v) => (v === value && count++));
                return count;
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            closeS2(){
                this.$refs.successModal2.classList.remove("bg-active");
            },

            unFollowClick(fol){

                this.unfUserId = fol.userId;
                this.unfUsername = fol.username;

            },

            profileClick(userId, username){

                const auth = getAuth();

                if(auth.currentUser.uid == userId){
                    this.$router.push({name: 'profile'});
                    return;
                }

                sessionStorage.setItem("otherId", userId);
                this.$router.push({ name: 'other-profile', params: { id: username } });
                return;

            },

            async getFollowers(){

                const auth = getAuth();
                const querySnapshot = await getDocs(collection(db, "UserFollowers", auth.currentUser.uid, "Followers"));

                if(querySnapshot.docs.length > 0){

                    document.getElementById("emptyFollowers").style.display = "none";

                    querySnapshot.forEach((doc) => {
                        this.followerCount++;

                        this.getFollowerInfo(doc.id);
                    })

                }

                this.getFans();

            },

            async getFollowerInfo(id){

                let followBack = false;

                if(this.getOccurrence(this.followingIdList, id) > 0){
                    followBack = true;
                }

                const userRef = doc(db, "Users", id);
                const userSnap = await getDoc(userRef);

                if(userSnap.exists()){
                    this.followerList.push({
                        userId: userSnap.data().userId,
                        profilePic: userSnap.data().profilePic,
                        username: userSnap.data().displayId,
                        name: userSnap.data().name,
                        userType: userSnap.data().type,
                        followBack: followBack,
                    })
                }

            },

            async getFollowingInfo(id){

                const userRef = doc(db, "Users", id);
                const userSnap = await getDoc(userRef);

                if(userSnap.exists()){
                    this.followingList.push({
                        userId: userSnap.data().userId,
                        profilePic: userSnap.data().profilePic,
                        username: userSnap.data().displayId,
                        name: userSnap.data().name,
                        userType: userSnap.data().type,
                    })
                }

            },

            async getFollowing(){

                this.loadingText = "Getting user lists...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();
                const querySnapshot = await getDocs(collection(db, "UserFollowing", auth.currentUser.uid, "Following"));

                if(querySnapshot.docs.length > 0){

                    document.getElementById("emptyFollowing").style.display = "none";

                    querySnapshot.forEach((doc) => {
                        this.followingCount++
                        this.followingIdList.push(doc.id)
                        this.getFollowingInfo(doc.id)
                    })

                }

                this.getFollowers();

            },

            async getFans(){

                const auth = getAuth();
                const querySnapshot = await getDocs(collection(db, "UserFans", auth.currentUser.uid, "Fans"));

                if(querySnapshot.docs.length > 0){

                    document.getElementById("emptyFans").style.display = "none";

                    querySnapshot.forEach((doc) => {
                        this.fanCount++;

                        let a1 = String(new Date(Number(doc.data().startDate.seconds) * 1000));
                        let a2 = String(new Date(Number(doc.data().endDate) * 1000));

                        this.fanList.push({
                            fullName: doc.data().fullName,
                            username: doc.data().username,
                            profilePic: doc.data().profilePic,
                            price: doc.data().price,
                            priceD: Number(doc.data().price).toLocaleString("us-US"),
                            duration: doc.data().duration,
                            startDate: doc.data().startDate,
                            startDateD: a1.slice(0, -45),
                            endDate: doc.data().endDate,
                            endDateD: a2.slice(0, -45),
                            status: doc.data().status,
                            userId: doc.data().userId,
                            email: doc.data().email,
                        })
                    })

                }

                this.$refs.loadingModal.classList.remove("bg-active");

            },

            async followUser(fol){

                this.spamCount++;
                if(this.spamCount > 2){
                    return;
                }

                this.loadingText = "Following @"+fol.username+"...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();

                await setDoc(doc(db, "UserFollowing", auth.currentUser.uid, "Following", fol.userId),{
                    userId: fol.userId,
                    fullname: fol.name,
                    username: fol.username,
                    profilePic: fol.profilePic,
                    timeStamp: serverTimestamp(),
                });
                const userRef = doc(db, "Users", auth.currentUser.uid);
                await updateDoc(userRef, {
                    followingCount: increment(1),
                });

                await setDoc(doc(db, "UserFollowers", fol.userId , "Followers",  auth.currentUser.uid),{
                    userId: auth.currentUser.uid,
                    fullname: sessionStorage.getItem("fullName"),
                    username: sessionStorage.getItem("userName"),
                    profilePic: sessionStorage.getItem("profilePic"),
                    timeStamp: serverTimestamp(),
                });
                const userRef2 = doc(db, "Users", fol.userId);
                await updateDoc(userRef2, {
                    followersCount: increment(1),
                });

                // NOTIFICATION
                if(fol.userId != auth.currentUser.uid){

                    const notiRef = doc(db, "Users", fol.userId);
                    await updateDoc(notiRef, {
                        notiCount: increment(1),
                    });

                    let mSecs = new Date().getTime()/1000;
                    let secs = 10000000000 / mSecs

                    await addDoc(collection(db, "UserNoti"),{
                        category: "Users",
                        description: "Started following you",
                        ownerId: fol.userId,
                        userId: auth.currentUser.uid,
                        username: sessionStorage.getItem("userName"),
                        fullName: sessionStorage.getItem("fullName"),
                        profilePic: sessionStorage.getItem("profilePic"),
                        email: sessionStorage.getItem("email"),
                        date: serverTimestamp(),
                        dateN: secs,
                        postId: "",
                    });

                }

                //add them to my contact list
                await setDoc(doc(db, "UserContact", auth.currentUser.uid , "Contact",  fol.userId),{
                        userId: fol.userId,
                        fullName: fol.name,
                        userName: fol.username,
                        profilePic: fol.profilePic,
                        userType: fol.userType,
                    });

                //add me to their contact list
                await setDoc(doc(db, "UserContact", fol.userId , "Contact",  auth.currentUser.uid),{
                        userId: auth.currentUser.uid,
                        fullName: sessionStorage.getItem("fullName"),
                        userName: sessionStorage.getItem("userName"),
                        profilePic: sessionStorage.getItem("profilePic"),
                        userType: sessionStorage.getItem("userType"),
                    });

                this.successText = "Successfully followed @"+fol.username;
                this.$refs.successModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");

            },

            async unfollowUser(){

                this.spamCount++;
                if(this.spamCount > 2){
                    return;
                }

                this.loadingText = "Unfollowing @"+this.unfUsername+"...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();

                await deleteDoc(doc(db, "UserFollowing", auth.currentUser.uid, "Following", this.unfUserId));
                const userRef = doc(db, "Users", auth.currentUser.uid);
                await updateDoc(userRef, {
                    followingCount: increment(-1),
                });

                await deleteDoc(doc(db, "UserFollowers", this.unfUserId , "Followers",  auth.currentUser.uid));
                const userRef2 = doc(db, "Users", this.unfUserId);
                await updateDoc(userRef2, {
                    followersCount: increment(-1),
                });

                this.followerCount--;

                this.successText = "Successfully unfollowed @"+this.unfUsername;
                this.$refs.successModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");

            },

            goMessage(){
                this.$router.push({name: 'messages'})
            }


        }


        
    }
</script>